export default "__VITE_ASSET__B60u5mAF__"